$(function() {
    PsrLoader.init();
    GenericProductHandler.init();
    PsrProfileSelectorModal.init();
    PsrProfileSelectorForm.init();
    PsrProfileSelect.init();
    PsrProfilePeriodSelect.init();

    if (PsrHelpers.getParameterByName("openPop") === "pop") {
        PsrProfileSelectorModal.launch();
    }

    $(".js-modal-profile").on("click", function(event) {
        event.preventDefault();

        var initModalType = this.dataset.modalInit;
        var data = {};

        if (initModalType === "start-selection") {
            data = {
                itemCartCode: this.dataset.itemCartCode,
                productCode: this.dataset.productCode,
                productStatus: this.dataset.productStatus,
                productType: this.dataset.productType
            };
        }

        PsrProfileSelectorModal.launch(initModalType, data);
    });
});
